export default "__VITE_ASSET__C3O0ccRB__"